// AUTO-GENERATED by scripts/generate-build-info.js — do not edit by hand.
export const BUILD_INFO = {
  version: '0.0.0',
  commit: '760f50f6',
  branch: 'dev',
  buildTime: '2026-07-14T12:43:45.128Z',
} as const;
